import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, mergeProps as _mergeProps, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/consultations/mic.svg'


const _hoisted_1 = { class: "areaGrid" }
const _hoisted_2 = { style: {"position":"relative"} }
const _hoisted_3 = ["rows", "placeholder"]
const _hoisted_4 = { class: "line-svg pad-s" }
const _hoisted_5 = {
  key: 0,
  class: "flex-square-20 filter-grey"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "flex-square-20 filter-grey" }

import { ref, computed, watch, nextTick } from 'vue';
import stylesJS from '@/assets/styles.js';
import sttapi from '@/api/sttapi';


export default /*@__PURE__*/_defineComponent({
  __name: 'inputAreaAuto2',
  props: /*@__PURE__*/_mergeModels({
  id: {
    type: String,
    default: ""
  },
  hover: {
      type: Boolean,
      default: false,
  },
  mic: {
      type: Boolean,
      default: false,
  },
  showMenu: {
    type: Boolean,
    default: false,
  },
  styles: {
    type: String,
    default: ""
  },
  placeholder: {
    type: String,
    default: ""
  },
  lines: {
    type: Number,
    default: null
  },
  lastRow: {
    type: Boolean,
    default: false,
  }
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(['clickMenu'], ["update:modelValue"]),
  setup(__props, { expose: __expose, emit: __emit }) {

const userText = _useModel(__props, "modelValue");
const props = __props;

const emits = __emit;

const showMic = computed(() => {
  return (recording.value === true || hasFocus.value)
})

const hasFocus = ref(false)	
const innerRef = ref(null)
const inputTextRef = ref(null)

const hasClick = ref(false);


const divUserText = computed(() => {
  const inputString = userText.value
  if (!inputString) { return 'i' }

  const lastChar = inputString.slice(-1);
  return (lastChar === '\n' || lastChar === '\r') ? inputString + 'i' : inputString
})


const classList = computed(() => {
  // Import & defaults
  let importOBJ = stylesJS.get(props.styles)
  let iAlign = importOBJ.align || "l"
  iAlign = "align-" + iAlign
  let iMain = importOBJ.main || "h"
  iMain = "main-" + iMain
  let iBg = importOBJ.bg || "0"
  iBg = "bg-" + iBg
  let iFont = importOBJ.font || "m"
  iFont = "font-" + iFont
  let iPad = importOBJ.pad  || "s"
  iPad = "pad-" + iPad
  let iPLeft = importOBJ.pleft  || "08"
  iPLeft = "pleft-" + iPLeft

  return ['component', 'border-none', iMain, iAlign, iBg, iFont, iPad, iPLeft]
})

function resize() {
  if (props.lines) return;
  if (!innerRef.value) return;
  innerRef.value.style.height = "auto"
  innerRef.value.style.height = `${inputTextRef.value.offsetHeight + 2}px`;
}


// Microphone
const recording = ref(false)
const mediaRecorder = ref(null)
const chunks = ref([])

function keyDownForMic(event) {
  if (recording.value === true) {
    event.preventDefault()
    return
  }
  if (showMic.value === false) {return;}
  // if (event.ctrlKey && (event.key === ' ' || event.keyCode === 32)) {
  // // if (event.altKey  && event.key.toLowerCase() === 'm') {
  if (event.ctrlKey  && event.key.toLowerCase() === 'm') {
    event.preventDefault()
    startRecording()
  }
}

function keyUpForMic(event) {
  if (recording.value === false) {
    return
  }  
  event.preventDefault()
  stopRecording()
}


function mouseDownForMic() {
  if (showMic.value === false) {return;}
  startRecording()
}

function mouseUpForMic() {
  if (recording.value === false) {
    return
  }    
  stopRecording()
}

async function startRecording() {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
    mediaRecorder.value = new MediaRecorder(stream)
    chunks.value = []
    mediaRecorder.value.addEventListener('dataavailable', event => {
      chunks.value.push(event.data)
    })
    recording.value = true
    mediaRecorder.value.start()
  } catch (error) {
    recording.value = false
    console.error('Error accessing microphone:', error)
  }
}

async function stopRecording() {
  if (!recording.value) return
  recording.value = false
  if (!mediaRecorder.value) return

  //Save some textArea properties
  const oldText = userText.value
  const selStart = innerRef.value.selectionStart
  const selEnd = innerRef.value.selectionEnd

  // Stop the recording
  mediaRecorder.value.stop()

  // Wait for the 'stop' event to ensure all data is available
  await new Promise(resolve => {
    mediaRecorder.value.addEventListener('stop', resolve)
  })

  // Combine all recorded data into a single Blob
  const recordedAudio = new Blob(chunks.value, { type: 'audio/webm' });

  //Local audio-file save for debugging
  const DEBUG = false
  if (DEBUG) {
    const url = URL.createObjectURL(recordedAudio)
    const link = document.createElement('a')
    link.href = url
    link.download = 'recorded-audio.webm'
    link.click()
    URL.revokeObjectURL(url)   
  }

  //API call
  const recognizedText = await sttapi.stt(recordedAudio)
  if (DEBUG)
    {console.log(recognizedText)}
  if (!recognizedText?.result?.trim()) {console.log("No or empty recognizedText.result"); return;}

  //Update Text
  const textInsert = " " + recognizedText.result.trim() + " "
  const newText = oldText.slice(0, selStart) + textInsert + oldText.slice(selEnd);
  const focusPos = selEnd + textInsert.length
  userText.value = newText
  
  //Focus
  nextTick(() => {
    resize()
    innerRef.value.focus()
    innerRef.value.setSelectionRange(focusPos, focusPos)
  })

}

function focusOn() {
  hasFocus.value = true
}

function focusOff() {
  hasFocus.value = false
}

function updateFromBackend() {
  nextTick(() => {
    resize()
  })
}

function clickMenu() {
  emits('clickMenu');
}


__expose({
  innerRef
})

watch(
  () => userText.value,
  () => {
    updateFromBackend();
  },
  { immediate: true }
)


return (_ctx: any,_cache: any) => {
  const _component_svg_item = _resolveComponent("svg-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        ref_key: "inputTextRef",
        ref: inputTextRef,
        class: _normalizeClass(["hidden-div", classList.value])
      }, _toDisplayString(divUserText.value), 3),
      _withDirectives(_createElementVNode("textarea", _mergeProps(_ctx.$attrs, {
        ref_key: "innerRef",
        ref: innerRef,
        spellcheck: "false",
        class: classList.value,
        rows: props.lines ? props.lines : null,
        placeholder: __props.placeholder,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userText).value = $event)),
        onFocus: focusOn,
        onKeydown: keyDownForMic,
        onKeyup: keyUpForMic
      }), "      ", 16, _hoisted_3), [
        [_vModelText, userText.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (props.mic)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: _normalizeStyle([{"align-self":"start"}, {'visibility': props.hover || (props.lastRow && userText.value === '') ? 'visible' : 'hidden'}]),
            class: "row gap-01",
            onMousedown: _cache[1] || (_cache[1] = ($event: any) => (mouseDownForMic())),
            onMouseup: _cache[2] || (_cache[2] = ($event: any) => (mouseUpForMic()))
          }, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "mleft-02" }, null, -1)),
            (!recording.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[4] || (_cache[4] = [
                  _createElementVNode("img", {
                    src: _imports_0,
                    class: "w-full h-full square-14"
                  }, null, -1)
                ])))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[5] || (_cache[5] = [
                  _createElementVNode("img", {
                    src: _imports_0,
                    class: "w-full h-full square-14"
                  }, null, -1)
                ])))
          ], 36))
        : _createCommentVNode("", true),
      (props.showMenu)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            style: _normalizeStyle([{"align-self":"start"}, {'visibility': props.hover || (props.lastRow && userText.value === '') ? 'visible' : 'hidden'}]),
            class: "row gap-01",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (clickMenu()))
          }, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "mleft-02" }, null, -1)),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_svg_item, {
                icon: "moreVertical",
                styles: "size-l"
              })
            ])
          ], 4))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})